import Role from '@/enums/role';

const ROLES_ALLOWED_TO_USE_PPN: readonly Role[] = [Role.GLS_ADMIN, Role.PARTNER_CREATOR, Role.PARTNER_OPERATOR];

export { ROLES_ALLOWED_TO_USE_PPN };
